module.exports = __webpack_public_path__ + "static/Kaggle-c60702ef57e8e7da6766cb249f02354b.png";